export default __webpack_public_path__ + "static/media/aqi_band_6.6452d94b.svg";